import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import enUS from 'antd/locale/en_US';
import { AuthProvider } from './hooks';
import { useVideoGenerationNotifications } from './hooks/useVideoGenerationNotifications';
import { AppLayout } from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import { Login } from './pages/auth';
import { Stories, StoryDetail } from './pages/stories';
import { Tags } from './pages/tags';
import { Users } from './pages/users';
import { SourceStories, SourceStoryDetail } from './pages/source-stories';
import PromptTemplates from './pages/prompt-templates';
import ImageStyles from './pages/image-styles';
import { AudioLibrary } from './pages/audio-library';
import TaskMonitoringPage from './pages/admin-tasks/TaskMonitoringPage';
import { ROUTES } from './constants';
import './App.css';

function AppContent() {
  // Global background notification polling
  useVideoGenerationNotifications();

  return (
    <Routes>
      {/* Public routes */}
      <Route path={ROUTES.LOGIN} element={<Login />} />
      
      {/* Protected routes */}
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <AppLayout>
              <Routes>
                <Route path={ROUTES.STORIES} element={<Stories />} />
                <Route path={ROUTES.STORY_DETAIL} element={<StoryDetail />} />
                <Route path={ROUTES.TAGS} element={<Tags />} />
                <Route path={ROUTES.USERS} element={<Users />} />
                <Route path={ROUTES.SOURCE_STORIES} element={<SourceStories />} />
                <Route path={ROUTES.SOURCE_STORY_DETAIL} element={<SourceStoryDetail />} />
                <Route path={ROUTES.PROMPT_TEMPLATES} element={<PromptTemplates />} />
                <Route path={ROUTES.IMAGE_STYLES} element={<ImageStyles />} />
                <Route path={ROUTES.AUDIO_LIBRARY} element={<AudioLibrary />} />
                <Route path={ROUTES.AUTO_TASKS} element={<TaskMonitoringPage />} />
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
              </Routes>
            </AppLayout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <ConfigProvider locale={enUS}>
      <AuthProvider>
        <Router>
          <AppContent />
        </Router>
      </AuthProvider>
    </ConfigProvider>
  );
}

export default App;
